import React, { Component } from 'react';
import { getTransactionType } from '../../api/paymentApi';
import successImage from '../../images/success.png';
import { fetchTicket } from '../../api/flightApi';
import { Button } from 'semantic-ui-react';
import { downloadTicket } from '../../helpers/general';
import { Link } from 'react-router-dom';

class PaymentSuccess extends Component {
  state = { loading: false, bookingType: null };

  componentDidMount() {
    const idx = this.props.match.params.idx;
    if (idx) {
      getTransactionType(idx)
        .then((r) => this.setState({ bookingType: (r.data && r.data.booking_type) || 'unknown' }))
        .catch(() => this.setState({ bookingType: 'unknown' }));
    }
  }

  download(idx) {
    this.setState({ loading: true });
    fetchTicket(idx).then((r) => { downloadTicket(r.data); this.setState({ loading: false }); }).catch(() => this.setState({ loading: false }));
  }

  render() {
    const { idx } = this.props.match.params;
    const { loading, bookingType } = this.state;
    const isGroupTourism = ['GROUP_TOURISM', 'GROUP_TOURISM_REST', 'GROUP_TOURISM_ADDITIONAL_INTEREST'].includes(bookingType);
    const isSharedRental = ['SHARED_RENTAL', 'SHARED_RENTAL_REST', 'SHARED_RENTAL_ADDITIONAL_INTEREST'].includes(bookingType);

    return (
      <div className="container">
        <div className="card">
          <div className="card-body text-center">
            <h3 className="title">Payment successful</h3>
            <div className="text-center">
              <img src={successImage} alt="" style={{ width: '100px', height: '100px' }} />
            </div>
            {isGroupTourism && (
              <>
                <p className="mt-3 text-muted">We&apos;ve received your interest. We&apos;ll email you when the group is formed so you can pay the rest.</p>
                <p className="mt-1 text-muted small" style={{ fontSize: '0.85rem' }}>Interest is refunded if the group does not form. Once the group is confirmed, payment is non-refundable if you cancel.</p>
              </>
            )}
            {isSharedRental && (
              <>
                <p className="mt-3 text-muted">We&apos;ve received your interest. We&apos;ll email you when the team is formed so you can pay the rest.</p>
                <p className="mt-1 text-muted small" style={{ fontSize: '0.85rem' }}>Interest is refunded if the group does not form. Once the group is confirmed, payment is non-refundable if you cancel.</p>
              </>
            )}
            <div className="mt-3">
              {isGroupTourism ? (
                <Link to="/group-trips" className="btn btn-primary btn-large">Back to Group Trips</Link>
              ) : isSharedRental ? (
                <Link to="/shared-rentals" className="btn btn-primary btn-large">Back to Shared Rentals</Link>
              ) : (
                <Button primary loading={loading} className="btn btn-primary btn-large" onClick={() => this.download(idx)}>
                  Download ticket
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PaymentSuccess;
